(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-icon"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function inicializar(seccion) {
      if (!seccion || seccion.dataset.categoriasPortadaInit === 'true') return;
      var carrusel = seccion.querySelector('[data-categorias-portada-carrusel]');
      var barra = seccion.querySelector('[data-categorias-portada-progreso-barra]');
      var contenedor = seccion.querySelector('[data-categorias-portada-progreso]');
      if (!carrusel || !barra || !contenedor) return;

      seccion.dataset.categoriasPortadaInit = 'true';

      function actualizar() {
        var contenedorAncho = contenedor.clientWidth;
        var scrollTotal = carrusel.scrollWidth - carrusel.clientWidth;

        if (scrollTotal <= 0 || contenedorAncho <= 0) {
          barra.style.width = '100%';
          barra.style.transform = 'translate3d(0, 0, 0)';
          return;
        }

        var proporcionVisible = carrusel.clientWidth / carrusel.scrollWidth;
        var porcentajeBarra = Math.max(proporcionVisible * 100, 20);
        var anchoBarraPx = (porcentajeBarra / 100) * contenedorAncho;
        var maxDesplazamientoPx = contenedorAncho - anchoBarraPx;
        var progreso = carrusel.scrollLeft / scrollTotal;
        if (progreso < 0) progreso = 0;
        if (progreso > 1) progreso = 1;
        var desplazamientoPx = progreso * maxDesplazamientoPx;

        barra.style.width = porcentajeBarra + '%';
        barra.style.transform = 'translate3d(' + desplazamientoPx + 'px, 0, 0)';
      }

      var tickScroll = false;
      carrusel.addEventListener('scroll', function () {
        if (!tickScroll) {
          window.requestAnimationFrame(function () {
            actualizar();
            tickScroll = false;
          });
          tickScroll = true;
        }
      }, { passive: true });

      var tickResize = false;
      window.addEventListener('resize', function () {
        if (!tickResize) {
          window.requestAnimationFrame(function () {
            actualizar();
            tickResize = false;
          });
          tickResize = true;
        }
      });

      if (window.ResizeObserver) {
        var ro = new ResizeObserver(function () { actualizar(); });
        ro.observe(carrusel);
      }

      window.setTimeout(actualizar, 50);
      window.setTimeout(actualizar, 300);
      actualizar();
    }

    function iniciarTodas() {
      var secciones = document.querySelectorAll('[data-categorias-portada]');
      for (var i = 0; i < secciones.length; i++) inicializar(secciones[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciarTodas);
    } else {
      iniciarTodas();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target.querySelector('[data-categorias-portada]');
      if (s) inicializar(s);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
